<template>
  <section>
    <div class="topup-form">
      <div class="topup-form-frame">
        <h1 v-html="$t('component.autotopup.start.header')"></h1>
        <div class="topup-types-list">
          <div class="topup-types-list-content">
            <div class="topup-types-list-container">
              <button role="link"
                      id="topupTypeSingle"
                      @click="goToTopupSingle"
                      v-html="$t('component.autotopup.start.topupSingle')"
                      :title="$t('component.autotopup.start.a11y.nav.topupTypeSingle')"></button>
            </div>
            <div class="topup-types-list-container">
              <button role="link"
                      id="topupTypeAuto"
                      @click="goToTopupAuto"
                      v-html="$t('component.autotopup.start.topupAuto')"
                      :title="$t('component.autotopup.start.a11y.nav.topupTypeAuto')"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StartMixin from '@/common/mixins/Topup/Auto/Start.mixin'

export default {
  name: 'TopupAutoStart',
  mixins: [StartMixin]
}
</script>

<style src="../../../assets/scss/topup-form.scss" lang="scss"></style>
